import React from 'react'
import className from 'classnames/bind'
import { Source } from 'plyr'

import Modal from 'app/components/modal/modal.component'
import VideoPlayer from 'app/components/video-player/video-player.component'
import { PlayIconRounded } from 'app/components/icons'

import stylesModule from 'app/components/modal/custom-modal/video-modal.module.scss'

const cx = className.bind(stylesModule)

type VideoModalProps = {
  close: () => void
  poster: string
  sources: Source[]
}

const VideoModal = ({ close, poster, sources }: VideoModalProps) => (
  <Modal
    selectors="button, div.plyr, .plyr__controls *"
    close={close}
    classNameList={{
      wrapper: cx('video-modal'),
      main: cx('video-modal__main'),
      closeButton: cx('video-modal__close-button'),
    }}
  >
    <VideoPlayer
      placeholder
      classNames={cx('video-modal__player')}
      poster={poster}
      source={{
        type: 'video',
        poster,
        sources,
      }}
      tracks={[]}
      playButtonIcon={
        <PlayIconRounded className={cx('video-modal__play-button')} />
      }
    />
  </Modal>
)

export default VideoModal
